import { Component, inject } from '@angular/core';
import { LocalityTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LocalityTypeCreateDto,
  LocalityTypeDto,
  LocalityTypeExcelDownloadDto,
  LocalityTypeUpdateDto,
} from '../proxy/planning/dtos/locality-type';
import { LOCALITYTYPE_CONFIG, LOCALITYTYPE_FIELDS } from './locality-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-locality-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LocalityTypeService, ConfirmationService],
  templateUrl: './locality-type.html',
  styleUrl: './locality-type.scss',
})
export class LocalityType extends BaseCrudComponent<
  LocalityTypeDto,
  LocalityTypeCreateDto,
  LocalityTypeUpdateDto,
  LocalityTypeExcelDownloadDto
> {
  service = inject(LocalityTypeService);
  config = LOCALITYTYPE_CONFIG;
  fields = LOCALITYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: LocalityTypeDto): LocalityTypeUpdateDto {
    return {
      name: data.name,
      rangeOfInhabitants: data.rangeOfInhabitants,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LocalityType';
  }
}
